import { Wish } from 'es6/collections/wish'
import { recommendationsEvents } from 'init/recommendations-events'

/**
 * Коллекция для избранного
 */
export const wish = new Wish({ recommendationsEvents: recommendationsEvents })
